import React from 'react'
import { classnames } from 'begonya/functions'

import Image from '@/components/base/image'

import {
  GlomilOrganizationChartProps,
  GlomilOrganizationManager,
  GlomilOrganizationGroupEmployee,
} from './types'
import Icon from '@/components/base/icon/Icon'
import Anchor from '@/components/base/anchor/Anchor'

const GlomilOrganizationChart: React.FunctionComponent<
  GlomilOrganizationChartProps
> = ({ data = [] }) => {
  const getGrouppedManagers = (parent?: GlomilOrganizationManager) => {
    let group: Array<GlomilOrganizationGroupEmployee> = []

    const mapping = (
      data: GlomilOrganizationManager
    ): GlomilOrganizationGroupEmployee => ({
      name: data.name,
      surname: data.surname,
      image: data.image,
      depertmant: data.depertmant,
      order: data.order,
      sector: data.sector ? data.sector : '',
      children: getGrouppedManagers(data),
      linkedin: data.linkedin,
    })

    if (parent) {
      for (const manager of data) {
        const isChildren = manager.parentId === parent.id

        if (isChildren) {
          if (!parent.sector) {
            group.push(mapping(manager))
          } else {
            group.push(mapping({ ...manager })) // sector: undefined
          }
        }
      }
    } else {
      const rootManager = data.find((item) => !item.sector)

      if (rootManager) {
        group.push(mapping(rootManager))
      }
    }

    return group
  }

  const renderEmployee = (manager: GlomilOrganizationGroupEmployee) => {
    return (
      <React.Fragment>
        <div className="organization-items-item-detail">
          <Image {...manager.image} alt={manager.name} />
          <div className="organization-items-item-detail-desc">
            <div>
              <div className="organization-items-item-detail-desc-title">
                {manager.name} <b>{manager.surname}</b>
              </div>
              <div className="organization-items-item-detail-desc-department">
                {manager.depertmant}
              </div>
            </div>
            {manager.linkedin && (
              <div className="social-media">
                <Anchor href={manager.linkedin?.href}>
                  <Icon name="icon-linkedin1" />
                </Anchor>
              </div>
            )}
          </div>
        </div>

        {manager.children?.length ? (
          <div className="organization-items">
            {(manager.children || [])
              .sort((a, b) => a.order - b.order)
              .map((manager) => (
                <div
                  key={manager.name}
                  className={classnames(
                    'organization-items-item',
                    manager.sector && 'has-sector',
                    manager.children?.length && 'has-manager'
                  )}
                >
                  {manager.sector && (
                    <div className="organization-items-sector-title">
                      {manager.sector}
                    </div>
                  )}

                  {renderEmployee(manager)}
                </div>
              ))}
          </div>
        ) : null}
      </React.Fragment>
    )
  }

  const renderManagers = () => {
    const managers = getGrouppedManagers()

    return managers.map((manager, index) => (
      <div key={index} className="organization-items-item">
        {renderEmployee(manager)}
      </div>
    ))
  }

  return <div className="organization-items">{renderManagers()}</div>
}

export default GlomilOrganizationChart
